export const definirComplement = (complement) => (dispatch) => {
    dispatch({ type: 'definirComplement', payload: complement });
};
export const titreReducer = (state = {}, action = {}) => {
    switch (action.type) {
        case 'definirComplement':
            return { ...state, complement: action.payload };
        default:
            return state;
    }
};
